export default "__VITE_ASSET__BsPRjgzR__"